import { useAuthStore } from "./auth.store";
import { Navigate, useLocation } from "react-router-dom";

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();
  console.log("PrivateRoute check:", location.pathname, "Auth:", isAuthenticated);
  
  return isAuthenticated ? children : <Navigate to="/login" replace state={{ from: location }} />;
}

export default PrivateRoute;
